var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.config.show,
            expression: "config.show"
          }
        ],
        staticClass: "modal modal-nopadding modal-80 flex",
        style: { zIndex: _vm.zIndex },
        attrs: { transition: "fade" }
      },
      [
        _c("div", {
          staticClass: "modal-backdrop in",
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "900px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("button", {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.config.show = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("h4", { staticClass: "modal-title" }, [_vm._v("选择3D场景")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "hbox" }, [
                  _c("aside", { staticClass: "aside" }, [
                    _c(
                      "ul",
                      { staticClass: "list-group swm_side" },
                      [
                        _c(
                          "li",
                          {
                            staticClass: "list-group-item",
                            class: {
                              current: !_vm.currentGroup
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectGroup(null)
                              }
                            }
                          },
                          [
                            _c("a", { attrs: { href: "javascript:void(0)" } }, [
                              _vm._v("全部")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "list-group-item",
                            class: {
                              current:
                                _vm.currentGroup &&
                                "ungroup" === _vm.currentGroup.objectId
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectGroup({ objectId: "ungroup" })
                              }
                            }
                          },
                          [
                            _c("a", { attrs: { href: "javascript:void(0)" } }, [
                              _vm._v("未分组")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.groups, function(g) {
                          return [
                            _c(
                              "li",
                              {
                                staticClass: "list-group-item",
                                class: {
                                  current:
                                    _vm.currentGroup &&
                                    g.objectId === _vm.currentGroup.objectId
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectGroup(g)
                                  }
                                }
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [_vm._v(" " + _vm._s(g.title) + " ")]
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "material-img-list project-list clearfix" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "section",
                        {
                          staticClass: "win-list win-video-list",
                          staticStyle: { height: "475px" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row gutter-5" },
                            _vm._l(_vm.list, function(it) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-6 col-sm-4 col-md-3 col-lg-2"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      class: {
                                        active:
                                          _vm.current &&
                                          it.objectId === _vm.current.objectId
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.select(it)
                                        },
                                        dblclick: function($event) {
                                          return _vm.dbClick(it)
                                        }
                                      }
                                    },
                                    [
                                      _c("h5", [_vm._v(_vm._s(it.title))]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "img-rect-wrap" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "img-rect" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "img-wrap" },
                                                [
                                                  _c("img", {
                                                    attrs: { src: it.coverUrl }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item-overlay",
                                          class: {
                                            checked:
                                              _vm.current &&
                                              it.objectId ===
                                                _vm.current.objectId
                                          }
                                        },
                                        [_vm._m(1, true)]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pull-right padding-right-10" },
                            [
                              _c("c-pagination", {
                                attrs: { "pagination-conf": _vm.paginationConf }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn m-white",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.close()
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn m-green",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.ok()
                      }
                    }
                  },
                  [_vm._v("确定")]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-grey-cararra padding-10 ovh-imp" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-8" }, [
          _c("form", { staticClass: "form-inline" }, [
            _c("div", { staticClass: "input-group input-group-sm" }, [
              _c("input", {
                staticClass: "form-control",
                staticStyle: { width: "240px" },
                attrs: {
                  type: "text",
                  placeholder: "搜索关键字",
                  name: "query"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn m-green btn-sm", attrs: { type: "submit" } },
              [_c("i", { staticClass: "icon-magnifier" }), _vm._v(" 搜索")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "view-icon", attrs: { href: "javascript:void(0);" } },
      [
        _c("i", { staticClass: "fa fa-square-o" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-check-square-o" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }